/**
 * Script de nettoyage des anciennes clés localStorage
 * 
 * À exécuter une seule fois pour migrer vers le nouveau système
 * avec clés associées au DID
 */

/**
 * Nettoyer toutes les anciennes clés localStorage qui ne sont pas associées à un DID
 */
function cleanupLegacyLocalStorage() {
  const legacyKeys = [
    // Twitter
    'globalBatchId',
    'twitterAccountConfigured',
    'twitterTargetAccount',
    'twitterAccountSkipped',
    
    // Discord
    'discord_channelId',
    'discord_guildId',
    'discord_currentAnalysisBatchId',
    'discord_analyzingChannelId',
    'discord_analyzingChannelName',
    'discord_batchId_discord',
    'discord_selectedChannel',
    
    // LinkedIn
    'linkedinAccountConfigured',
    'linkedinTargetAccount',
    'linkedinAccountSkipped',
    
    // Mentions
    'mentionBrandConfigured',
    'mentionBrandName'
  ];
  
  let cleanedCount = 0;
  
  // Nettoyer les clés exactes
  legacyKeys.forEach(key => {
    if (localStorage.getItem(key) !== null) {
      localStorage.removeItem(key);
      cleanedCount++;
    }
  });
  
  // Nettoyer les clés avec préfixes legacy
  const legacyPrefixes = [
    'savedDates_twitter_',
    'savedDates_linkedin_',
    'savedDates_discord_',
    'savedDates_mentions_',
    'compareMode_twitter_',
    'compareMode_linkedin_',
    'compareMode_discord_',
    'compareMode_mentions_',
    'periodType_twitter_',
    'periodType_linkedin_',
    'periodType_discord_',
    'periodType_mentions_',
    'memberSortFilter_twitter_',
    'memberSortFilter_linkedin_',
    'memberSortFilter_discord_',
    'memberSortFilter_mentions_',
    'analyzedChannels',
    'discord_analyzed_'
  ];
  
  Object.keys(localStorage).forEach(key => {
    // Vérifier si la clé commence par un préfixe legacy
    const isLegacy = legacyPrefixes.some(prefix => key.startsWith(prefix));
    
    // Vérifier si la clé ne commence PAS par 'analyzer_' (nouveau format)
    const isNotNewFormat = !key.startsWith('analyzer_');
    
    if (isLegacy && isNotNewFormat) {
      localStorage.removeItem(key);
      cleanedCount++;
    }
  });
}

/**
 * Afficher toutes les clés localStorage actuelles
 */
function listAllLocalStorageKeys() {
  const analyzerKeys = [];
  const otherKeys = [];
  
  Object.keys(localStorage).forEach(key => {
    if (key.startsWith('analyzer_')) {
      analyzerKeys.push(key);
    } else {
      otherKeys.push(key);
    }
  });
  return { analyzerKeys, otherKeys };
}

/**
 * Obtenir les statistiques localStorage
 */
function getLocalStorageStats() {
  const analyzerKeys = Object.keys(localStorage).filter(k => k.startsWith('analyzer_'));
  const legacyKeys = Object.keys(localStorage).filter(k => !k.startsWith('analyzer_'));
  
  const totalSize = new Blob(Object.values(localStorage)).size;
  
  return {
    totalKeys: Object.keys(localStorage).length,
    analyzerKeys: analyzerKeys.length,
    legacyKeys: legacyKeys.length,
    totalSize
  };
}

// Exporter pour utilisation dans la console
if (typeof window !== 'undefined') {
  window.cleanupLegacyLocalStorage = cleanupLegacyLocalStorage;
  window.listAllLocalStorageKeys = listAllLocalStorageKeys;
  window.getLocalStorageStats = getLocalStorageStats;
}

export { cleanupLegacyLocalStorage, listAllLocalStorageKeys, getLocalStorageStats };
